import EditorWorkspacePage from "./pages/EditorWorkspacePage";
import FileProcessingPage from "./pages/FileProcessingPage";
import GuidePage from "./pages/GuidePage";
import MarketingLandingPage from "./pages/MarketingLandingPage";

export default function App() {
  const path =
    typeof window !== "undefined"
      ? window.location.pathname.toLowerCase()
      : "/";
  if (path === "/" || path === "") {
    return <EditorWorkspacePage />;
  }
  if (path === "/home" || path === "/home/") {
    return <MarketingLandingPage />;
  }
  if (
    path === "/workspace" ||
    path === "/workspace/" ||
    path === "/editor" ||
    path === "/editor/"
  ) {
    return <EditorWorkspacePage />;
  }
  if (path === "/guide" || path === "/guide/") {
    return <GuidePage />;
  }
  if (
    path === "/process" ||
    path === "/process/" ||
    path === "/processing" ||
    path === "/processing/" ||
    path === "/file-processing" ||
    path === "/file-processing/"
  ) {
    return <FileProcessingPage />;
  }
  return <EditorWorkspacePage />;
}
